module.exports = __webpack_public_path__ + "static/descriptionphoto-215caf532f1fb2a13b9150735b83272d.jpg";